// URL BASE
//export const base_url = 'http://localhost:8005/api';

//export const base_url_clean = 'http://localhost:8005/';

export const base_url = 'https://apicoresys.ebtapps.com/api';
export const base_url_clean = 'https://apicoresys.ebtapps.com/';